module.exports = __webpack_public_path__ + "img/freespin1.c291d504.png";